import { CountUp, Reveal } from "@/components/primitives";
import { STATS } from "@/data/content";

export default function Stats() {
    return (
        <section className="border-t border-border py-16 md:py-20">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
                    {STATS.map((s, i) => (
                        <Reveal key={s.label} delay={i * 0.08}>
                            <div>
                                <div className="font-mono text-4xl font-medium tracking-tight text-foreground md:text-5xl">
                                    <CountUp value={s.value} suffix={s.suffix} />
                                </div>
                                <p className="mt-3 max-w-[12rem] text-sm leading-relaxed text-muted-foreground">
                                    {s.label}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
